import React from 'react';
import { Outlet } from 'react-router';
import './assets/nxvet.svg';
import  Logos from './assets/logo.svg?react';
import NervexLogo from './assets/nervex.svg?react';

// Same bundle serves app.nx.vet and app.nervex.tech — brand by host.
const isNervexHost = window.location.hostname === 'app.nervex.tech'
    || window.location.hostname.endsWith('.nervex.tech');
import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router-dom';


export const Layout = () => {
    const location = useLocation();

    return (
        <>
            <div className='flex flex-col justify-center items-center  w-full h-full bg-[#f1f1f1]'>
                <div className="pt-8 pb-5 w-full md:px-14 px-5 md:flex-nowrap flex-wrap items-center flex md:justify-between justify-center bg-[#f1f1f1]">
                    <NavLink to='/'>
                    {isNervexHost ? <NervexLogo /> : <Logos />}
                    </NavLink>

                    {
                        location?.pathname === '/signup' && (
                            <p className='text-[#595959] pt-5 md:pt-0 w-full md:text-right text-center'>
                                Already have account?
                                <NavLink to="/login" className="text-[#26818E] relative ml-2">Sign In</NavLink >
                            </p>
                        )
                    }
                    {
                        location?.pathname === '/login' && (
                            <p className='text-[#595959] pt-5 md:pt-0 w-full md:text-right text-center'>
                                Don't have an account yet?
                                <NavLink to="/signup" className="text-[#26818E] relative ml-2">Sign Up</NavLink >
                            </p>
                        )
                    }
                </div>  

                <div className='flex flex-row w-full'>
                    <div className='w-full' id='page-content'>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    );
}
